module.exports = __webpack_public_path__ + "static/img/icon-03.47f13d4e.png";